<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>IPOP</h2>
          <button pButton class="p-button-success save-button" label="Save"
                  [disabled]="getSaveButtonDisabled() || isSaving"
                  (click)="saveSettings()"></button>
        </div>
      </ng-template>
      <p-tabs [value]="0">
        <p-tablist>
          <p-tab [value]="0">Private Offers <i class="pi pi-lock"></i></p-tab>
          <p-tab [value]="1">VDP Offers <i class="pi pi-car"></i></p-tab>
          <p-tab [value]="2">Offer Set Rules <i class="pi pi-file"></i></p-tab>
        </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <auto-private-offers
            [data]="ipopConfiguration"
            (formGroupInitialized)="onPrivateOffersFormGroupInitialized($event)">
          </auto-private-offers>
        </p-tabpanel>
        <p-tabpanel [value]="1">
        <auto-vdp-offers
          [data]="ipopConfiguration"
          (formGroupInitialized)="onVdpOffersFormGroupInitialized($event)">
        </auto-vdp-offers>
          </p-tabpanel>
        <p-tabpanel [value]="2">
          <auto-offer-set-rules [accountId]="accountId"></auto-offer-set-rules>
        </p-tabpanel>
      </p-tabpanels>
      </p-tabs>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
